import BaseForgeCustomizer from '../base-forge';
import React from 'react';
import ProxyFooter from '../../components/common/ProxyFooter';
import AmplitudeUtils from '../../utils/amplitude-utils';

const ENROLL_POLL = 'enroll-poll';

export default class OktaVerifyEnrollBaseCustomizer extends BaseForgeCustomizer {

  displayFooterText = true;
  async shouldCustomize() {
    const { authenticatorKey, methodType } = this.context;
    return authenticatorKey === 'okta_verify' && methodType === 'push';
  }

  protected forgifyController() {
    this.onIdxProceed();
    super.forgifyController();
  }

  protected onIdxProceed() {
    const {
      oktaSignIn: { authClient },
    } = this;
    const originalProceed = authClient.idx.proceed.bind(authClient);
    authClient.idx.proceed = async (...args: any) => {
      const response = await originalProceed.apply(authClient, args);
      // For the enroll-poll step, the next step can either be enroll-poll (indicating that the
      // user has not yet enrolled in the Okta Verify app) or something else (indicating that
      // the user has successfully enrolled in the Okta Verify app).
      if (args[0].step === ENROLL_POLL && response.requestDidSucceed && response.nextStep?.name !== ENROLL_POLL) {
        AmplitudeUtils.logMfaEnrollEvent('OktaVerify::Success');
      }
      return response;
    };
  }

  // Text is not required since we have only one manual option
  protected hideSwitchChannelText() {
    this.hideComponent(jQueryCourage('.switch-channel-text')[0]);
  }

  protected getFooter({ footerLink }: { footerLink: JQuery }): React.JSX.Element {
    return (
      <ProxyFooter
        text={this.footerText}
        footerLinks={footerLink.not('[data-se=cancel]')}
        alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
      />
    );
  }
}
